﻿import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs } from "@app/helpers/dirs";
import { KbService } from "@app/services/kb.service";
import { IRootScope } from "@models";
import { StateService } from "@uirouter/angularjs";

export interface IMenuItemScope extends ng.IScope {
    icon: string;
    label: string;
}

@NgComponent({
    token: Token.KbMenuItem,
    dependencies: [
        Token.KbService,
        Token.$State,
        Token.$RootScope,
    ]
})
export class KbMenuItem extends Directive {
    constructor(
        private kbService: KbService,
        $state: StateService,
        $rootScope: IRootScope
    ) {
        super();

        this.restrict = "E";
        this.template = Dirs.component("kb-menu-item");
        this.scope = {
            icon: "@",
            label: "@",
            params: "=?"
        };
        this.replace = true;
        this.transclude = true;

        this.link = (scope: IMenuItemScope, element, atts) => {
            // remove the submenu element if there are no sub menu items
            let $subMenu = element.find(".kb-menu__sub");
            if (!$subMenu.html().length) {
                $subMenu.remove();
            }

            element.click(() => {
                let isExpanded = $(element).hasClass("is-expanded");
                $(element).children(".kb-menu__item").removeClass("is-expanded");

                if (!isExpanded) {
                    $(element).addClass("is-expanded");
                    let collapse = () => {
                        $(element).removeClass("is-expanded");
                        $("html").unbind("click", collapse);
                    };
                    setTimeout(() => { $("html").bind("click", collapse); }, 1);
                }
            });

            scope.$on("$destroy", () => {
                element.off();
            });
        };
    }
}
